<template>
    <v-container grid-list-md fluid>
        <img class="text-center" alt="Master Meal Planner logo" src="@/assets/logo.png" id="logo" @click="goToPath('/')">
        <h1 class="mmp-title">Master Meal Planner</h1>
        <v-layout row wrap>
            <h1>{{ msg }}</h1>
            <v-flex xs12 sm5 md5 lg5 class="mrgauto">
                <v-card>
                    <v-toolbar color="light-blue lighten-4" light>
                        <v-toolbar-title>{{title}}</v-toolbar-title>
                    </v-toolbar>
                    <v-card-text>
                        <!-- Login form -->
                        <v-form ref="form">
                            <v-text-field v-model="userInfoModel.email" :type="'email'" :rules="userRules.email" label="E-mail" required @input="validateLoginForm"></v-text-field>
                            <v-text-field v-model="userInfoModel.password" :type="'password'" :rules="userRules.password" label="Password" required @input="validateLoginForm"></v-text-field>
                            <v-btn :disabled='!isValidLoginForm || isLogin' depressed color="success" @click="login">Login</v-btn>
                        </v-form>
                    </v-card-text>
                </v-card>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
    import Utils from '@/services/Utils.js';
    import CONSTANT from '@/services/Constant.js';
    import UserService from '@/services/db/UserService.js';

    export default {
        name: "Login",
        props: {
            msg: String
        },
        data: () => ({
            title: 'Login',
            userInfoModel: {
                email: '',
                password: ''
            },
            valid: true,
            userRules: {
                email: [
                    v => !!v || 'E-mail is required',
                    v => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || 'E-mail must be valid'
                ],
                password: [
                    v => !!v || 'Password is required',
                    v => (v && v.length >= 8) || 'Password must be atleast 8 characters'
                ]
            },
            isValidLoginForm : false,
            isLogin : false
        }),
        methods: {
                /*
                * Method to validate login form
                */
                validateLoginForm() {
                    if (!this.userInfoModel || (!Utils.isValidEmail(this.userInfoModel.email) || this.userInfoModel.password.length < 8)
                    ) {
                        this.isValidLoginForm = false;
                    } else {
                        this.isValidLoginForm = true;
                    }
                },

                getDashboardByRole(_user){
                    return (_user['role'] == CONSTANT.ROLES.ADMIN)? 'admin-dashboard' : (_user['role'] == CONSTANT.ROLES.MANAGER)? 'manager-dashboard' : (_user['role'] == CONSTANT.ROLES.AUTHOR)? 'author-dashboard' : 'member-dashboard';
                },

                /*
                * Method to login user
                */
                login () {
                    if (this.isValidLoginForm) {
                        this.isLogin = true;
                        UserService.firebaseSignInWithEmailAndPassword(this.userInfoModel).then((user) => {
                            if(user.code){
                                this.$store.commit('setAlert', {isAlertError: true, message: (user.code == CONSTANT.MESSAGES.FIREBASE.CODE_USER_NOT_FOUND)? CONSTANT.MESSAGES.FIREBASE.USER_NOT_FOUND : CONSTANT.MESSAGES.FIREBASE.WRONG_PASSWORD });
                                this.isLogin = false;
                            } else {
                                if(user.user.uid){
                                    var _USER = user.user;

                                    UserService.getUserById(_USER.uid).then(getUser => {
                                        this.addUser(getUser, _USER, (addError, addUserSuccess) => {
                                            this.isLogin = false;
                                            if(addError){
                                                this.$store.commit('setAlert', {isAlertError: true, message: addError + 'test'});
                                            } else {
                                                this.$store.commit('setAlert', {isAlertSuccess: true, message: CONSTANT.MESSAGES.USER.LOGIN_SUCCESS});
                                                setTimeout(() => {
                                                    delete addUserSuccess['password'];
                                                    var _LOCATION = this.getDashboardByRole(addUserSuccess);


                                                    localStorage.setItem(CONSTANT.LOCAL_STORAGE.TOKEN, "JWT");
                                                    localStorage.setItem(CONSTANT.LOCAL_STORAGE.IS_AUTHETICATED, true);
                                                    localStorage.setItem(CONSTANT.LOCAL_STORAGE.LOGIN_USER, JSON.stringify(addUserSuccess));
                                                    this.$store.commit(CONSTANT.LOCAL_STORAGE.LOGIN_SUCCESS, addUserSuccess);
                                                    this.$store.commit(CONSTANT.LOCAL_STORAGE.IS_AUTHETICATED, true);
                                                    location.href = _LOCATION;
                                                }, 2000);

                                                // UserService.loginUser(this.userInfoModel).then((user) => {
                                                //     if(user !== null && user !== 0){
                                                //         this.$store.commit('setAlert', {isAlertSuccess: true, message: CONSTANT.MESSAGES.USER.LOGIN_SUCCESS});
                                                //         setTimeout(() => {
                                                //             delete user['password'];
                                                //             var _LOCATION = '/recipes';
                                                //             localStorage.setItem(CONSTANT.LOCAL_STORAGE.TOKEN, "JWT");
                                                //             localStorage.setItem(CONSTANT.LOCAL_STORAGE.IS_AUTHETICATED, true);
                                                //             localStorage.setItem(CONSTANT.LOCAL_STORAGE.LOGIN_USER, JSON.stringify(user));
                                                //             this.$store.commit(CONSTANT.LOCAL_STORAGE.LOGIN_SUCCESS, user);
                                                //             this.$store.commit(CONSTANT.LOCAL_STORAGE.IS_AUTHETICATED, true);
                                                //             location.href = _LOCATION;
                                                //         }, 1000);
                                                //     } else if(user == 0){
                                                //         this.$store.commit('setAlert', {isAlertError: true, message: CONSTANT.MESSAGES.USER.INVALID_PASSWORD});
                                                //     } else {
                                                //         this.$store.commit('setAlert', {isAlertError: true, message: CONSTANT.MESSAGES.USER.USER_NOT_FOUND});
                                                //     }
                                                // });
                                            }
                                        });
                                    });
                                } else {
                                    this.$store.commit('setAlert', {isAlertError: true, message: CONSTANT.MESSAGES.USER.USER_NOT_FOUND});
                                    this.isLogin = false;
                                }
                            }
                        });
                    }
                },

                addUser(getUser, _USER, callback){
                    if(getUser){
                        callback(null, getUser);
                    } else {
                        var _user = {
                            email: _USER.email,
                            referCode: "",
                            referenceCode: "",
                            registrationDate: "",
                            showTutorial: true,
                            subscription: "basic",
                            role: "basic",
                            userCurrentEmail: "",
                            userId: _USER.uid
                        };

                        UserService.addNewUser(_user, _USER.uid)
                        .then(() => {
                            callback(null, _user);
                        })
                        .catch((error) => {
                            callback(error, null);
                        });
                    }
                },

                goToPath(path) {
                    this.$router.push(path);
                }             
            }

    };
</script>
<style scoped>
    #logo {
        margin-top:5px;
        margin-bottom:5px;
        width: 150px;
        margin: auto;
    }   
    .mmp-title {
        text-align:center;
        font-size:40px;
        line-height: 42px;
        font-weight:bold;
        margin:0px 0px 20px 0px;
    }   
</style>